/* global Blockly */
import React, { Component } from 'react';

class RoundToDecimal extends Component {
    static blockName = "math_round_to_decimal";
    static category = "Math";

    constructor(props) {
        super(props);

        Blockly.Blocks[this.constructor.blockName] = this.block();

        let generators = this.generators();
        for (let i in generators) {
            Blockly[i][this.constructor.blockName] = generators[i];
        }
    }

    block() {
        return {
            init:function(){
                this.appendValueInput("VALUE")
                    .appendField("round")
                    .setCheck("Number");
                this.appendValueInput("DECIMALS")
                    .appendField("to")
                    .setCheck("Number");
                this.appendDummyInput()
                    .appendField("decimals");
                // Provide values for all of these
                this.setPreviousStatement(false);
                this.setNextStatement(false);
                this.setOutput(true,"Number"); // add appropriate checks
                this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
                this.setColour(Blockly.Msg.MATH_HUE);
                this.setTooltip('round a value to the specified number of decimal places');
                this.setHelpUrl(Blockly.BASE_HELP_URL+'#math');
            }
        }
    }

    generators() {
        return {
            'JavaScript': function (block) {
                let val = Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_NONE);
                let decimals = Blockly.JavaScript.valueToCode(block, 'DECIMALS', Blockly.JavaScript.ORDER_NONE);
                let multiplier = 'Math.pow(10,'+decimals+')';
                let code = '(Math.round(toNumber('+val+')*'+multiplier+')/'+multiplier+')';
                return [code, Blockly.JavaScript.ORDER_ATOMIC]
            }
        }
    }

    // Should return null if block shouldn't appear in toolbox
    render() {
        return (
            <block type={this.constructor.blockName}>
                <value name="VALUE"><shadow type="math_number"><field name="NUM">0.123</field></shadow></value>
                <value name="DECIMALS"><shadow type="math_number"><field name="NUM">2</field></shadow></value>
            </block>
        );
    }
}

export default RoundToDecimal;
